"use client"
import * as React from "react"
import useEmblaCarousel, { type UseEmblaCarouselType } from "embla-carousel-react"
import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"

type CarouselApi = UseEmblaCarouselType[1]
type UseCarouselParameters = Parameters<typeof useEmblaCarousel>
type CarouselOptions = UseCarouselParameters[0]

const Carousel = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & { options?: CarouselOptions }
>(({ className, options, children, ...props }, ref) => {
  const [emblaRef, api] = useEmblaCarousel({ ...options })
  return (
    <div ref={ref} className={cn("relative", className)} {...props}>
      <div className="overflow-hidden" ref={emblaRef}>
        <div className="flex -ml-4">{children}</div>
      </div>
      <Button variant="outline" className="absolute left-4 top-1/2" onClick={() => api?.scrollPrev()}>Prev</Button>
      <Button variant="outline" className="absolute right-4 top-1/2" onClick={() => api?.scrollNext()}>Next</Button>
    </div>
  )
})
Carousel.displayName = "Carousel"

const CarouselItem = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn("min-w-0 shrink-0 grow-0 pl-4", className)} {...props} />
  )
)
CarouselItem.displayName = "CarouselItem"

export { Carousel, CarouselItem }
